import React, { useEffect, useState } from 'react';
import { Form, Modal, Input, Button, Checkbox, Table, Space, Upload, message, Image, Select, Typography, Row, Col, Tabs, Radio, RadioChangeEvent } from 'antd';
import { SyncOutlined ,LoadingOutlined} from '@ant-design/icons';
import { cpuUsage } from 'process';
import { getCurrentUser, listUser } from '../services/User';
import { API_PREFIX, SERVER_PREFIX } from '../config';
import { Get, Post } from '../utils/request';
import { Header } from 'antd/lib/layout/layout';
import Title from 'antd/lib/typography/Title';
import { getFixHeader } from '../utils/request';
import icon_power_on from './icon/power_on.svg';
import icon_power_off from './icon/power_off.svg';
import icon_mute from './icon/mute.svg'; 
import icon_audio from './icon/audio.svg';
const context:any =  {
    ref : null,
    currentView : "group"
}
const download = (url: string, filename: string) => {



    fetch(`${API_PREFIX}${url}`, {
        method: 'GET',
        headers: { ...getFixHeader() }
    })
        .then((response) => { return response.blob() })
        .then((blob: any) => {

            var url = window.URL.createObjectURL(blob);
            var a = document.createElement('a');
            a.href = url;
            a.download = filename;
            document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
            a.click();
            a.remove();  //afterwards we remove the element again         
        });
}
const Device = () => {
    const [groupItems, setGroupItems] = useState<any>([])
    const [groupItems1, setGroupItems1] = useState<any>([])
    const [groupItems2, setGroupItems2] = useState<any>([])
    // const [selectRows, setSelectRows] = useState<any>([])
    // const [currentView, setCurrentView] = useState<any>("group")

    const update = () => {
        Get(`/summary`, null).then((v) => {
            let allDevices: any = []
            let agentGroup: any = []
            //按照代理分组
            v.data.forEach((v: any) => {
                allDevices = allDevices.concat(JSON.parse(JSON.stringify(v.groupDevices)))
            })

            allDevices.forEach((v2: any) => {
                let currentGroup = agentGroup.find((v3: any) => {
                    return v3.name == v2.device.agent.ip
                })
                if (!currentGroup) {
                    currentGroup = {
                        id: v2.device.agent.ip,
                        name: v2.device.agent.ip,
                        groupDevices: []
                    }
                    agentGroup.push(currentGroup)
                }
                currentGroup.groupDevices.push(v2)

            })
            const nd = [...v.data]
            const group = nd.map((v: any) => {
                v.groupDevices.forEach((v5: any) => {
                    v5.groupName = v.name
                    v5.key = v5.device.id
                })
                return {
                    key: v.id,
                    label: v.name,
                    children: renderDevice(v.groupDevices),

                }
            })
            setGroupItems1(group)

            const group2 = agentGroup.map((v: any) => {
                v.groupDevices.forEach((v5: any) => {
                    v5.groupName = v.name
                    v5.key = v5.device.id
                })
                return {
                    key: v.id,
                    label: v.name,
                    children: renderDevice(v.groupDevices),

                }
            })
            setGroupItems2(group2)

            if (context.currentView == "group")
                setGroupItems(group)
            else
                setGroupItems(group2)

        }).catch((e) => {
            console.log("error", e)
        });

    }

    const onChangeView = ({ target: { value } }: RadioChangeEvent) => {
        context.currentView = value
        if (value == "group")
            setGroupItems(groupItems1)
        else
            setGroupItems(groupItems2)

    };

    //设备操作
    const deviceAction = (id: string, action: string) => {
        const modal = Modal.info(
            {
                title:"", 
                icon : null,
                centered : true,
                width:100,                
                okButtonProps : {style:{display:"none"}},
                content:<SyncOutlined spin style={{fontSize:48}}/>

        }
        )
        Post(`/ctrl?ids=${id}&action=${action}`, {}).then((v) => {
            update()
        }).finally(()=>{
            modal.destroy()
        })
    }
    //批量设备操作
    const batchDeviceAction = (action: string) => {
        if(context.ref.length<=0) return
        deviceAction(context.ref.join(","), action)
    }
    // rowSelection object indicates the need for row selection
    const rowSelection = {
        onChange: (selectedRowKeys: React.Key[], currentSelectedRows: any) => {
            console.log('rowselect 当前选择 ', currentSelectedRows, selectedRowKeys);            
            context.ref = selectedRowKeys
            
        }
    };
    const groupOptions = [
        { label: '分组视图', value: 'group' },
        { label: '设备视图', value: 'agent' }
    ];
    const deviceColumn = [
        {
            title: '设备名称',
            dataIndex: 'name',
            key: 'name',
            render: (text: any, record: any) => (
                record.device.name
            ),
        }        ,
        {
            title: '分组',
            dataIndex: 'groupName',
            key: 'groupName'
        },

        {
            title: '代理',
            dataIndex: 'proxy',
            key: 'proxy',
            render: (text: any, record: any) => {
                if (record.device.agent.isOnline == 1)
                    return <Typography.Text type="success">{record.device.agent.ip}:{record.device.port}</Typography.Text>
                else
                    return <Typography.Text type="danger">{record.device.agent.ip}:{record.device.port}</Typography.Text>
            },
        },
       

        {
            title: '类型/型号',
            dataIndex: 'device.type',
            key: 'type',
            render: (text: any, record: any) => {
                const vtype = record.device.type == "switch"?"开关":record.device.type
                const modal = record.device.modal  == "general"?"普通":record.device.modal
                return `${vtype}/${modal}`
            },
        },
        
        {
            title: '设备状态',
            dataIndex: 'deviceState',
            key: 'deviceState',
            render: (text: any, record: any) => {
                let state = 0
                let curr = record.device.values.find((v: any) => {
                    return v.name == record.device.type
                })
                if (curr)
                    state = curr.value
                const stateMapper: any = {
                    "switch_1": icon_power_on,
                    "switch_0": icon_power_off,
                    "mute_0": icon_audio,
                    "mute_1": icon_mute,
                }
                const stateIcon = stateMapper[`${record.device.type}_${state}`]
                return <Typography.Text ><img style={{width:32,height:32}} src={stateIcon}/></Typography.Text>
            },

        },
        {
            title: '操作',
            key: 'action',
            render: (text: any, record: any) => {
                if (record.device.type == "switch")
                    return <Space size="middle">
                        <Button  type="primary"  onClick={() => deviceAction(record.device.id, "power_on")}>开</Button>
                        <Button  type="primary"  onClick={() => deviceAction(record.device.id, "power_off")}>关</Button>
                    </Space>
                else if (record.device.type == "audio")
                    return <Space size="middle">
                        <Button  type="primary"  onClick={() => deviceAction(record.device.id, "mute")}>静音</Button>
                        <Button  type="primary"  onClick={() => deviceAction(record.device.id, "unmute")}>放音</Button>
                        <Button  type="primary" onClick={() => deviceAction(record.device.id, "dec_volume")}>音量减</Button>
                        <Button type="primary" onClick={() => deviceAction(record.device.id, "add_volume")}>音量加</Button>

                    </Space>
            },
        },
    ]
    const renderDevice = (devices: any) => {
        console.log(devices)
        return <div>
            <Space>
                <Button type="primary" style={{backgroundColor:"#00CC33"}} onClick={()=>batchDeviceAction("power_on")}>总开</Button>                
                <Button type="primary"  danger={true} onClick={()=>batchDeviceAction("power_off")}>总关</Button>                
                <Button type="primary"  style={{backgroundColor:"#00CC33"}} onClick={()=>batchDeviceAction("unmute")}>放音</Button>                
                <Button type="primary"   danger={true}  onClick={()=>batchDeviceAction("mute")}>静音</Button>                
                
            </Space>
            <Table rowSelection={{
                type: "checkbox",
                ...rowSelection,
            }} dataSource={devices} columns={deviceColumn} />
        </div>
    }
    useEffect(update, [])
    const uploadPropsForScore = {
        name: 'file',
        multiple: false,
        ignore_files: 0,
        action: `${API_PREFIX}/devices/import`,
        showUploadList: false,

        headers: {
            "x-auth-token": getCurrentUser().token,
        },
        onChange(info: any) {
            if (info.file.status == "done") {

                const message = "导入完成!"
                Modal.info({
                    title: '提示',
                    centered: true,
                    content: (
                        <div>
                            <p>{message}</p>
                        </div>
                    ),

                    onOk() {
                        update()
                     },
                });

            }

        }
    };



    return <div style={{ margin: 0 }}>
        <h2 className='title'>设备管理</h2>
        <Row style={{ marginBottom: 15 }}>
            <Col span={24}>
                <Space>
                    <Button type="primary" onClick={() => download("/devices/template", "设备信息模板.xlsx")}>模板下载</Button>
                    <Button type="primary" onClick={() => window.open(`${SERVER_PREFIX}/static/help.html`,"_blank")}>模板说明</Button>
                    <Upload {...uploadPropsForScore}>
                        <Button type="primary">导入</Button>
                    </Upload>
                    <Button type="primary" onClick={() => download("/devices/export", "设备信息.xlsx")}>导出</Button>

                    
                </Space>
            </Col>
        </Row>

        <Row>
            <Col span={24} style={{ textAlign: "right" }}>
                <Radio.Group optionType="button" buttonStyle="solid" options={groupOptions} onChange={onChangeView} value={context.currentView} />
            </Col>
        </Row>
        <Row style={{ marginTop: 15 }}>
            <Col span={24}>
                <Tabs tabPosition={"left"} items={groupItems} type="line"></Tabs>
            </Col>
        </Row>

    </div>

};

export default Device;